import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { BrokerCode } from '../../../../types/brokerTypes';
import firebaseStore from '../../../stores/firebaseStore';
import modalStore, { ModalOption } from '../../../stores/modalStore';
import { apiClient } from '../../../clientUtils/apiClient';
import LoginForm from '../../login/LoginForm';
import UserInfoSetupModal from '../../my/UserInfoSetupModal';
import { CommonLink } from '../CommonLink';
import { Modal } from './Modal';

const LoginModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const onSuccess = async () => {
        modalStore.setReturnValue(modalId, true);

        // 로그인 성공 후 firebaseStore 가 업데이트될 때까지 대기
        _.delay(async () => {
            const currentUser = await apiClient.user.member.getCurrentUser.query();

            // 기존 모달 닫기
            await modalStore.close(modalId);

            if (currentUser?.needAgree) {
                // 추가 정보 입력 모달 표시
                const { returnValue } = await modalStore.custom<{
                    birthYear: number;
                    brokers: BrokerCode[];
                }>({
                    renderComponent: ({ modalId: setupModalId }) => (
                        <UserInfoSetupModal modalId={setupModalId} />
                    ),
                    preventClose: true,
                    showCloseButton: false,
                });

                if (returnValue) {
                    await apiClient.user.member.updateUserInfo.mutate({
                        birthYear: returnValue.birthYear,
                        brokers: returnValue.brokers,
                    });
                }
            }
        }, 300);
    };

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <div className="pt-11 pb-13">
                    <LoginForm onSuccess={onSuccess} />
                </div>
                <div className="text-base-content/50 text-[12px] leading-normal">
                    로그인하면 해와오의{' '}
                    <CommonLink to="/terms" target="_blank" className="link">
                        이용약관
                    </CommonLink>{' '}
                    및{' '}
                    <CommonLink to="/privacy" target="_blank" className="link">
                        개인정보처리방침
                    </CommonLink>
                    에 동의하게 됩니다.
                    <br />이 사이트는 reCAPTCHA로 보호되며, Google{' '}
                    <CommonLink
                        to="https://policies.google.com/privacy"
                        target="_blank"
                        className="link"
                    >
                        개인정보처리방침
                    </CommonLink>
                    과{' '}
                    <CommonLink
                        to="https://policies.google.com/terms"
                        target="_blank"
                        className="link"
                    >
                        서비스 약관
                    </CommonLink>
                    이 적용됩니다.
                </div>
            </Modal.BodyScroll>
            {!firebaseStore.isLoggingIn && <Modal.CloseXButton />}
        </Modal.Dialog>
    );
});

export default LoginModal;
